const BITS = [16, 8, 4, 2, 1];
const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

export function decodeGeohash(geohash) {
  var even = true;
  var lat = [-90.0, 90.0];
  var lon = [-180.0, 180.0];
  var lat_err = 90.0;
  var lon_err = 180.0;

  var i, j;
  for (i = 0; i < geohash.length; i++) {
    let c = geohash[i];
    let cd = BASE32.indexOf(c);
    for (j = 0; j < 5; j++) {
      let mask = BITS[j];
      if (even) {
        lon_err /= 2;
        refineInterval(lon, cd, mask);
      } else {
        lat_err /= 2;
        refineInterval(lat, cd, mask);
      }
      even = !even;
    }
  }
  lat[2] = (lat[0] + lat[1]) / 2;
  lon[2] = (lon[0] + lon[1]) / 2;

  return { latitude: lat, longitude: lon };
}

function refineInterval(interval, cd, mask) {
  if (cd & mask) {
    interval[0] = (interval[0] + interval[1]) / 2;
  } else {
    interval[1] = (interval[0] + interval[1]) / 2;
  }
}

export function countCountries(view_counts_by_region_code) {
  var map = {};
  _.each(view_counts_by_region_code, (_, code) => {
    var parts = code.split('-');
    map[parts[1]] = true;
  });
  return _.keys(map).length;
}



// WEBPACK FOOTER //
// ./app/utils/geo.js